import * as React from 'react';
import { ActionGroup, Alert, Button, Form, FormAlert, FormGroup, FormHelperText, TextInput } from '@patternfly/react-core';
import { ExclamationCircleIcon } from '@patternfly/react-icons';
import ValidatedType from "@app/Type/ValidatedType";
import TypeAssertions from '@app/utils/TypeAssertions';
import UserAuthentication from '@app/Security/UserAuthentication';
import FormAlertInterface from '@app/Interface/FormAlertInterface';

const ForgotForm: React.FC = () => {

    const [email, setEmail] = React.useState("");

    const [validEmail, setValidEmail] = React.useState<ValidatedType>("default");

    const [formValidated, setFormValidated] = React.useState<ValidatedType>("default");

    const [formAlertMessage, setFormAlertMessage] = React.useState<FormAlertInterface>({ variant: "default", title: "", isInline: true });

    const [isFormProcessing, setIsFormProcessing] = React.useState(false);

    const handleSubmit = async (event: React.SyntheticEvent) => {

        event.preventDefault();

        setIsFormProcessing(true);

        setValidEmail("default");

        setFormValidated("default");

        // TODO: Determine how to check for valid email address
        if (TypeAssertions.isStringNullOrEmpty(email)) {

            setValidEmail("error");

        } else {

            const wasReset = await UserAuthentication.resetUserPassword(email);

            if (wasReset) {

                setFormValidated("success");

                setFormAlertMessage({variant: "success", title: "A reset password link was sent to your email address.", isInline: true});

            } else {

                setFormValidated("error");

                setFormAlertMessage({variant: "danger", title: "An error occured attempting to process reset password. Please check that you have a valid email address and try again.", isInline: true});

            }
        }

        setIsFormProcessing(false);

    };

    return (
        <Form onSubmit={handleSubmit}>
            {formValidated !== "default" && (
                <FormAlert>
                    <Alert
                        variant={formAlertMessage.variant}
                        title={formAlertMessage.title}
                        aria-live="polite"
                        isInline={formAlertMessage.isInline}
                        role="alert"
                    ></Alert>
                </FormAlert>
            )}
            <FormGroup
                label="Email"
                type="string"
                helperText={
                    <FormHelperText icon={<ExclamationCircleIcon />} isHidden={validEmail !== "error"}>Please enter an email address.</FormHelperText>
                }
                helperTextInvalid="Enter email address"
                helperTextInvalidIcon={<ExclamationCircleIcon />}
                fieldId="email"
                validated={validEmail}
            >
                <TextInput
                    validated={validEmail}
                    value={email}
                    id="email"
                    aria-describedby="email-helper"
                    onChange={(newValue: string) => setEmail(newValue)}
                />
            </FormGroup>
            <ActionGroup>
                <Button variant="primary" onClick={handleSubmit} isDisabled={isFormProcessing}>
                    {isFormProcessing ? "Sending" : "Submit"}
                </Button>
            </ActionGroup>
        </Form>

    );

}

export default ForgotForm;